// @flow

import assortment from './reducers';

export {
  receiveAssortment,
  generateFacets,
  toggleTermFilter,
  applyRangeFilter,
  deleteRangeFilter,
  resetFilters,
  removeAllFilters,
  updateSort,
  updateAssortmentSort,
  getFiltersFromUrl,
  filterAssortment,
  toggleCustomFilter,
} from './actions';

export {
  getFilteredAssortment,
  getAssortment,
  isSelectedTermFilter,
  getRangeFilter,
  getMinMaxFromFacet,
  getSelectedFilters,
  getSelectedFiltersCount,
  hasFilters,
  getResultCount,
  getSortKey,
  isSelectedCustomFilter,
} from './selectors';

export type { State } from './types';

export default assortment;
